/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoIndicator {
        restrict = "E";
        scope = {
            ngDisabled: "=ngDisabled"

        };
        template = `
                        <md-button ng-disabled=\"ngDisabled\" >
                            <md-icon style="fill:#ff9999" md-svg-icon="assets/images/icons/revert_to_icon.svg" class="globe ng-scope" aria-hidden="true"></md-icon>
                        </md-button>
                    `

        //class="udc-purple"
        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {

            //var html = angular.element(indicator);
            //var htmlCompile = this.$compile(element)(scope);
            //element.append(htmlCompile);
            //element.parent().first().append(indicator);

        }

        constructor() {

        }
        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoIndicator();
            };
            directive.$inject = [];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoIndicator", MeevoIndicator.factory());
}

            // TODO: Render as Attribute adding html
            //var domElement = document.querySelector("[ng-model = 'context.selectedSection.model.appointmentBookSettings.allowAnonymousClient']"); 
            //let ele = angular.element(domElement).css({ color: 'red' });
            //let info = `
            //            <div layout-left-margin style="width: 25px; padding: 5px;">
            //                <md-button ng-click="context.showSettingInfo('allowAnonymousClient', context.selectedSection.model.appointmentBookSettings);" >
            //                    <md-icon md-svg-icon="assets/images/icons/circle_information.svg" class="globe ng-scope" aria-hidden="true"></md-icon>
            //                </md-button>
            //            </div>
            //        `
            //angular.element(ele).append(info);